import script from "./spinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./spinner.vue?vue&type=script&setup=true&lang=ts"

import "./spinner.vue?vue&type=style&index=0&id=39eca5aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39eca5aa"]])

export default __exports__